define('shared/initializer/form/newHouseAdapters/mixins/NoCardDebugletable',[
    'shared/lib/RSVP',
    'shared/util/hub',
    'shared/util/state',
    'shared/initializer/form/constants'

], function(
    RSVP,
    hub,
    state,
    constants
){
    function Ctor() { }

    Ctor.prototype.doPageLoad = function () {
        hub
            .get('/debuglet/settings')
            .then(function(settings){
                settings['No Card Payment'] = {
                    getValue: function() {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve(false);
                            }
                            else {
                                state
                                    .get(constants.State.NoCard)
                                    .then(function(values){
                                        resolve(values[0] && values[0].value || false);
                                    });
                            }
                        });
                    },
                    setValue: function(value) {
                        return new RSVP.Promise(function(resolve) {
                            if ( state == null ) {
                                resolve();
                            }
                            else {
                                state
                                    .push(constants.State.NoCard, {value: value})
                                    .then(function(){
                                        resolve();
                                    });
                            }
                        });
                    }
                };
            });
      };

    return Ctor;
});
